import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { getI18nInstance } from '../../locales/i18n';
import { cssDetailsRow } from '../../utils/styles';
import { DetailFieldVariant, DetailsField } from '../components/detailsField';
export const BatonTransmissionDetails = ({ transmissionDetails, error, language }) => {
    var _a;
    const t = getI18nInstance().getFixedT(language);
    return _jsxs("div", Object.assign({ css: cssDetailsRow }, { children: [_jsx(DetailsField, { label: t('itemTransmission.transmissionDetail.status'), value: ((_a = transmissionDetails === null || transmissionDetails === void 0 ? void 0 : transmissionDetails.status) === null || _a === void 0 ? void 0 : _a.toString()) && getStatusMessageFromCode(transmissionDetails.status.toString()) }), _jsx(DetailsField, { label: t('itemTransmission.transmissionDetail.message'), value: transmissionDetails === null || transmissionDetails === void 0 ? void 0 : transmissionDetails.message }), (transmissionDetails === null || transmissionDetails === void 0 ? void 0 : transmissionDetails.description) && _jsx(DetailsField, { label: t('itemTransmission.transmissionDetail.description'), value: transmissionDetails === null || transmissionDetails === void 0 ? void 0 : transmissionDetails.description }), error && _jsx(DetailsField, { label: t('itemTransmission.transmissionDetail.title'), value: error, variant: DetailFieldVariant.Danger })] }));
};
const getStatusMessageFromCode = (status) => {
    switch (status) {
        case '200':
            return 'Success';
        case '400':
        case '500':
            return 'Failed';
        default:
            return status;
    }
};
